import { z } from "zod"

/**
 * @description
 *	The schema of {@link FeatureFlag} type.
 */
export const FeatureFlagSchema = z.coerce.string().transform(_ => (_ === "true" ? true : false))

/**
 * @description
 *	A boolean feature flag.
 */
export type FeatureFlag = z.infer<typeof FeatureFlagSchema>
